/**
 * Biveris Products Block Frontend JavaScript
 *
 * @package Modern_Blocks
 */
import './frontend.css';

(function() {
	'use strict';

	// Initialize animations when DOM is ready
	document.addEventListener('DOMContentLoaded', function() {
		initBiverisProductsAnimations();
	});

	/**
	 * Initialize animations for biveris products block
	 */
	function initBiverisProductsAnimations() {
		const biverisProductsBlocks = document.querySelectorAll('.biveris-products-block');
		
		biverisProductsBlocks.forEach(block => {
			// Set up intersection observer for animations
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						animateBlock(entry.target);
						observer.unobserve(entry.target);
					}
				});
			}, {
				threshold: 0.1,
				rootMargin: '0px 0px -50px 0px'
			});

			observer.observe(block);
		});
	}

	/**
	 * Animate block elements with staggered delays
	 */
	function animateBlock(block) {
		const animationType = block.dataset.animationType || 'fade-up';
		const baseDelay = parseFloat(block.dataset.animationDelay) || 0.2;
		
		// Animate company logo
		const logoSection = block.querySelector('.company-logo-section');
		if (logoSection) {
			animateElement(logoSection, animationType, baseDelay);
		}

		// Animate product items with staggered delays
		const productItems = block.querySelectorAll('.biveris-product-item');
		productItems.forEach((item, index) => {
			const delay = parseFloat(item.dataset.animationDelay) || (baseDelay + (index * 0.2));
			animateElement(item, animationType, delay);
		});
	}

	/**
	 * Animate individual element
	 */
	function animateElement(element, animationType, delay) {
		if (!element) return;
		//element.classList.add('animate-in');return;

		// Set initial state based on animation type
		setInitialAnimationState(element, animationType);
		
		// Apply animation after delay
		setTimeout(() => {
			element.classList.add('animate-in');
		}, delay * 1000);
	}

	/**
	 * Set initial animation state based on type
	 */
	function setInitialAnimationState(element, animationType) {
		// Remove any existing animation classes
		element.classList.remove('animate-in', 'animate-fade-up', 'animate-fade-in', 'animate-slide-left', 'animate-slide-right', 'animate-scale-up', 'animate-bounce-in');
		
		// Add the appropriate animation class
		element.classList.add(`animate-${animationType}`);
	}

	// Re-initialize when new content is loaded (for dynamic content)
	if (typeof wp !== 'undefined' && wp.hooks) {
		wp.hooks.addAction('blocks.updated', 'modern-blocks/biveris-products', function() {
			setTimeout(() => {
				initBiverisProductsAnimations();
			}, 100);
		});
	}

})();